import Axios, { AxiosRequestConfig } from 'axios';
import {
	setConnectionInterceptor,
	setDefaultInterceptor,
} from './interceptors';
import Cookies from '../../lib/cookies';

type HttpMethods = 'get' | 'post' | 'delete' | 'put' | 'patch';

type InterceptorType = 'user' | 'client' | 'guest';

abstract class Request {
	// Instance default API request object
	static instance(
		configs?: AxiosRequestConfig,
		interceptor: InterceptorType = 'user'
	) {
		const axios = Axios.create({});

		const baseURL = `${process.env.REACT_APP_API_BASE_URL}`;

		axios.defaults.timeout = 30000;
		axios.interceptors.request.use(
			async function (config) {
				const token =
					interceptor === 'user'
						? Cookies.getAccessToken()
						: Cookies.getClientAccessToken();
				if (token) {
					config.headers['Authorization'] =
						`Bearer ${token.access_token}`;
					config.headers['Access-Control-Allow-Credentials'] = true;
				}
				config.headers['Content-Type'] =
					configs?.headers?.['Content-Type'] || 'application/json';
				config.baseURL = baseURL;

				return config;
			},
			function (error) {
				return Promise.reject(error);
			}
		);
		return axios;
	}

	// Default request function export
	static async request(
		url: string, // like `/my/url`
		method: HttpMethods,
		configs?: AxiosRequestConfig,
		useInterceptors: InterceptorType = 'user'
	) {
		const axios = Request.instance(configs, useInterceptors);

		if (useInterceptors === 'guest') setConnectionInterceptor(axios);
		else setDefaultInterceptor(axios);

		try {
			const response = await axios.request({
				method,
				url,
				...configs,
			});
			return response.data;
		} catch (error) {
			throw error;
		}
	}
}

export default Request.request;
